<template>
  <div class="max-w-6xl mx-auto px-4 py-8">
    <h1 class="text-4xl font-bold text-gray-900 dark:text-white mb-4">
      Premium Notfallrucksack Gefüllt & Einsatzbereit für 72h Autarkie
    </h1>
    <p class="text-xl text-gray-600 dark:text-gray-300 mb-8">
      Keine Kompromisse bei Deiner Sicherheit!
    </p>

    <!-- Hero Section -->
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6 mb-8">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
        <div>
          <img
            :src="product.image || '/placeholder.jpg'"
            alt="Notfallrucksack"
            class="w-full rounded-lg"
          >
        </div>
        <div>
          <p class="text-lg mb-4">
            {{ $t('product.description') }}
          </p>
          <p class="text-lg mb-4">
            {{ $t('product.unique') }}
          </p>
          <div class="flex space-x-4 mb-4">
            <button
              class="bg-blue-500 text-white px-6 py-3 rounded-md font-semibold"
              @click="addToCart"
            >
              In den Warenkorb
            </button>
            <span class="text-2xl font-bold text-primary">{{ product.price }} €</span>
          </div>
          <p class="text-sm text-gray-500">
            Lieferzeit: {{ product.lead_time || '5-7 Werktage' }}
          </p>
        </div>
      </div>
    </div>

    <!-- Features -->
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
      <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
        <h2 class="text-xl font-semibold mb-2">
          72 Stunden Autarkie
        </h2>
        <p>Über 70 Artikel für 3 Tage Versorgung.</p>
      </div>
      <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
        <h2 class="text-xl font-semibold mb-2">
          7 Module
        </h2>
        <p>Blitzschneller Zugriff.</p>
      </div>
      <div class="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
        <h2 class="text-xl font-semibold mb-2">
          Wetterfest
        </h2>
        <p>Robust und 100% wetterfest.</p>
      </div>
    </div>

    <!-- Technical Details -->
    <div class="bg-white dark:bg-gray-800 rounded-lg shadow-lg p-6 mb-8">
      <h2 class="text-2xl font-semibold mb-4">
        Technische Details
      </h2>
      <ul class="grid grid-cols-1 md:grid-cols-2 gap-2">
        <li>Material: Wetterfestes Premium-Polyester</li>
        <li>Volumen: 75 Liter</li>
        <li>Abmessungen: Höhe 82 cm, Breite 40-45 cm, Tiefe 25-30 cm</li>
        <li>Gewicht: 10-11,5 kg</li>
        <li>Farben: Grün, Sand, Schwarz</li>
      </ul>
    </div>

    <!-- Modules -->
    <div class="mb-8">
      <h2 class="text-2xl font-semibold mb-4">
        7 Module
      </h2>
      <div
        v-for="module in modules"
        :key="module.id"
        class="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6 mb-4"
      >
        <h3 class="text-xl font-semibold mb-2">
          {{ module.name }}
        </h3>
        <ul class="list-disc pl-5">
          <li
            v-for="item in module.items"
            :key="item"
          >
            {{ item }}
          </li>
        </ul>
      </div>
    </div>

    <button
      class="bg-blue-500 text-white px-8 py-4 rounded-md font-semibold text-lg"
      @click="addToCart"
    >
      Jetzt bestellen - {{ product.price }} €
    </button>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useMedusaStore } from '@/stores/medusa'
import { useRouter } from 'vue-router'

const { t } = useI18n()
const medusa = useMedusaStore()
const router = useRouter()

const product = ref({})
const modules = ref([])

const productId = 'notfallrucksack-id' // Annahme, dynamisch aus Route

onMounted(async () => {
  const response = await medusa.client.products.retrieve(productId)
  product.value = response.product
  // Lade Module aus Statik oder Medusa Metadata
  modules.value = [
    {
      id: 1,
      name: 'Escape / Flucht',
      items: ['Pfeife', 'Schutzbrille', 'Stirnlampe', /* ... aus Spec */]
    },
    // Weitere Module aus Spezifikation
    // ... (verkürzt, vollständige Liste einfügen)
  ]
})

const addToCart = async () => {
  await medusa.addToCart(product.value.variants[0].id)
  const base = router.currentRoute.value.path.startsWith('/de') ? '/de/cart' : '/cart'
  router.push(base)
}
</script>
